// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Link, { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import { menuSecondaryNavigationItemStyles } from "@store/Themes/common/mixins/menu";
import { headerLinkListIcons } from "@store/Overrides/Widgets/Header/HeaderLinkList";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

export const visualizerMenuIcon = headerLinkListIcons.eye;
export const visualizerMenuOnClick = () => {
    if (typeof window !== "undefined") {
        (window as any).roomvo?.startStandaloneVisualizer?.();
    }
};

const enum fields {
    showIcon = "showIcon",
    title = "title",
}

export interface VisualizerMenuProps extends WidgetProps {
    fields: {
        [fields.showIcon]: boolean;
        [fields.title]: string;
    };
}

export interface VisualizerMenuStyles {
    wrapper?: InjectableCss;
    link?: LinkPresentationProps;
}

export const visualizerMenuStyles: VisualizerMenuStyles = {
    wrapper: {
        css: css`
            ${menuSecondaryNavigationItemStyles()}
        `,
    },
    link: {
        icon: {
            position: "left",
            iconProps: {
                src: visualizerMenuIcon.src,
                color: "inherit",
                css: css`
                    ${iconScalableStyles(visualizerMenuIcon.size, visualizerMenuIcon.offset)}
                    margin-right: ${x => x.theme.design.menu.secondaryNavigation.iconSpacing};
                `,
            },
        },
        css: css`
            ${linkStyles("inherit", "menu.secondaryNavigation.hover", false, true)}
        `,
    },
};

const styles = visualizerMenuStyles;

export const VisualizerMenu: FC<VisualizerMenuProps> = ({ fields: { showIcon, title } }) => {
    const enableVisualizer = useSettingsCollection().customSettings?.enableVisualizer;

    if (!enableVisualizer) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Link {...styles.link} icon={showIcon ? styles.link?.icon : undefined} onClick={visualizerMenuOnClick}>
                {title}
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: VisualizerMenu,
    definition: {
        displayName: "Visualizer Menu",
        icon: "eye",
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.showIcon,
                displayName: "Show Icon",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.title,
                fieldType: "Contextual",
                editorTemplate: "TextField",
                defaultValue: "Emser Tile Visualizer",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
